// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceState
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DataSourceState = /*#__PURE__*/function (DataSourceState) {
  DataSourceState[DataSourceState["NORMAL"] = 0] = "NORMAL";
  DataSourceState[DataSourceState["CHANGE"] = 1] = "CHANGE";
  DataSourceState[DataSourceState["ADD"] = 2] = "ADD";
  DataSourceState[DataSourceState["DELETE"] = 3] = "DELETE";
  return DataSourceState;
}({});
(function (_DataSourceState) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DataSourceState[enumVal] != null ? enumVal : undefined : DataSourceState[enumVal];
  }
  _DataSourceState.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DataSourceState.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DataSourceState.indexOf = indexOf;
})(DataSourceState || (DataSourceState = {}));
//# sourceMappingURL=DataSourceState.js.map
